import { clickTrack } from '../../actions/products';
import { getImagePath } from '../../common/productImageUtils';

export const getPricecardData = async (pageNo = 1) => {
  const { getStore } = await import('../../../store/createStore');
  const { getMatchedUOM } = await import('../../utills');
  const { default: { get } } = await import('axios');
  const state = getStore().getState();
  const { session: { token }, uom: { productUOM } } = state;
  const params = {
    token,
    action: 'addPriceListing',
    pageNo
  }
  try {
    const { data } = await get('/marketplace/static/php/web/b2bWebsite.php', { params });
    if (data.status === 1) {
      const productData = data.data.productData?.map((l) => ({
        ...l,
        imageUrl: getImagePath(l.imageUrl, l.isTemplate),
        price: '',
        uom: null,
        error: '',
        showPriceRange: false,
        uom: getMatchedUOM(productUOM, l?.unitOfMeasurement)
      }));
      if (productData.length) {
        return {
          ...data.data,
          productData
        };
      }
      return {
        error: 'No Products Found.'
      }
    } else {
      return { error: 'Server Issue Please check again' }
    }
  } catch (error) {
    return { error: 'Server Issue Please check again' }
  }
}

export const validatedPriceCardData = async (productData) => {
  const { getStore } = await import('../../../store/createStore');
  const { default: { post } } = await import('axios');
  const state = getStore().getState();
  const { session: { token } } = state;
  const params = {
    token,
    action: 'addPrice',
    smartCardSource: 'ADD_PRICE'
  }
  const finalValues = [];
  for (let i = 0; i < productData.length; i += 1) {
    let values = {}
    let unitVal = ""
    if (productData[i].uom?.val == "stds" || productData[i].uom?.val == "Sess" || productData[i].uom?.val == "Visit") {
      unitVal = productData[i].unitOfMeasurement || ""
    } else {
      unitVal = productData[i].uom?.val || ""
    }
    if (productData[i].showPriceRange && productData[i].priceObj.minPrice && productData[i].priceObj.maxPrice) {
      values = {
        productId: productData[i].productId,
        price_range: true,
        min_price: productData[i].priceObj.minPrice,
        max_price: productData[i].priceObj.maxPrice,
        enquiry_price: '',
        unit: unitVal,
        categoryType: productData[i]?.categoryType
      }
      finalValues.push(values)
    } else if (!productData[i].showPriceRange && productData[i].price || productData[i].actualPrice || productData[i].discPrice) {
      values = {
        productId: productData[i].productId,
        price_range: false,
        min_price: '',
        max_price: '',
        unit: unitVal,
        categoryType: productData[i]?.categoryType
      }
      if (productData[i].price){
        values.enquiry_price = productData[i].price;
      }else {
        values.actualPrice = productData[i].actualPrice;
        values.discPrice = productData[i].discPrice;
      }
      finalValues.push(values);
    }
  }
  if (finalValues.length) {
    const form = new FormData();
    form.append('request', JSON.stringify(finalValues));
    const { data } = await post('/marketplace/static/php/web/b2bWebsite.php', form, { params });
    if (data.status === 1) {
      return { success: finalValues.length }
    } else if (data.status === 3) {
      return {
        error: data.msg,
        errData: data
      }
    } else {
      return {
        error: 'Server Error'
      }
    }
  }
  return {};
}

export const AddPriceCardDataonClick = async () => {
  const { getStore } = await import('../../../store/createStore');
  const { showMessage } = await import('jd-library/src/Toast/ToastAction');
  const { toggleProductCardSlider, pricecardDataFetched } = await import('../../actions/products');
  const { showHideLoader } = await import('../../actions');
  const dispatch = getStore().dispatch;
  
  const state = getStore().getState();
  const { profileObject } = state.session;
  
  dispatch(clickTrack({ll: 'digital_catalog',li: 'add_price',userBasedCheck: true}));
  dispatch(showHideLoader({ showLoader: true }));
  const { error, ...res } = await getPricecardData();
  if (error) {
    dispatch(showMessage({
      showToastMessage: true,
      message: `Unbale to Fetch ${profileObject.PluralLabelWithSpace}. Please try again after some time.`,
      type: 'info',
      duration: 5000
    }));
    dispatch(showHideLoader({ showLoader: false }));
  } else {
    dispatch(pricecardDataFetched(res));
    setTimeout(() => {
      dispatch(toggleProductCardSlider(true));
      dispatch(showHideLoader({ showLoader: false }));
    }, 200);
  }
}

export const debounceFunc = (func, delay) => {
    let timeoutId;
    return function (...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
}